import { generateGruserObjectId } from '../helpers';

import privileges from './privileges';
import modules from './modules';
import layout from './layout';
import gruserReducer from './gruser';
import page from './page';

const defaultState = {};

export default (state: any = defaultState, action) => {
  const { gruser } = action.payload || {};

  if (!gruser) {
    return state;
  }

  const gruserObjectId = generateGruserObjectId(gruser);

  const gruserObjectSlice = state[gruserObjectId] || {};
  return {
    ...state,
    [gruserObjectId]: {
      privileges: privileges(gruserObjectSlice.privileges, action),
      modules: modules(gruserObjectSlice.modules, action),
      layout: layout(gruserObjectSlice.layout, action),
      gruser: gruserReducer(gruserObjectSlice.gruser, action),
      page: page(gruserObjectSlice.page, action),
    },
  };
};
